import {Component, Input} from '@angular/core';

import { DialogRef } from '@progress/kendo-angular-dialog';
import {PedidosService} from "../services/pedidos.service";

@Component({
  selector: 'app-modal-vincular-comanda',
  templateUrl: './modal-vincular-comanda.component.html',
  styleUrls: ['./modal-vincular-comanda.component.scss']
})
export class ModalVincularComandaComponent {
  @Input() mesa: any = {};
  codigo = '';
  carregando = false;
  erro: string | null = null;
  selectedDevice: MediaDeviceInfo | null = null;
  // Propriedades para leitura de cartão do cliente
  leituraCartaoAberta = false;

  videoElement: HTMLVideoElement;
  barcodeDetector: any;
  streamAtivo: MediaStream | null = null;
  dispositivosDisponiveis: MediaDeviceInfo[] = [];
  dispositivoAtual  = '';
  leituraEmProgresso = false;
  constructor(private pedidosService: PedidosService, private dialogRef: DialogRef
  ) {

  }

  async enviar() {
    this.erro = null;
    this.codigo = String(this.codigo || '').trim();

    if(!this.codigo){
      this.erro = 'Não foi possível ler o QR Code da comanda. Tente novamente.';
      return;
    }

    this.carregando = true;
    try {
      let comanda: any = await this.pedidosService.obtenhaComandaDoCartao(this.mesa, this.codigo).catch((err: string) => {
        this.erro = this.traduzaErro(err);
      });

      if(comanda) {
        comanda.codigoCartaoCliente = this.codigo;
        this.dialogRef.close(comanda);
      }
    } catch (e: any) {
      this.erro = this.traduzaErro(e.message || 'Erro ao vincular comanda.');
    } finally {
      this.carregando = false;
    }
  }

  private traduzaErro(erro: string): string {
    if(!erro) return 'Erro ao vincular comanda. Tente novamente.';

    const erroLower = erro.toLowerCase();
    if(erroLower.includes('inexistente'))
      return 'Comanda não encontrada. Verifique o código e tente novamente.';
    if(erroLower.includes('inativ'))
      return 'Esta comanda está inativa. Solicite uma comanda ativa ao garçom.';
    if(erroLower.includes('outra mesa'))
      return 'Esta comanda já está vinculada a outra mesa.';
    if(erroLower.includes('dados inválidos'))
      return 'Dados inválidos. Confira o código da comanda e tente novamente.';

    return erro;
  }

  lerQRCode() {
    this.leituraCartaoAberta = true;
    this.erro = null;
    this.erroCameraPermissao = false;
  }

  erroCameraPermissao = false;

  onCameraError(error: any) {
    this.erroCameraPermissao = true;
    this.leituraCartaoAberta = false;
    this.erro = 'Não foi possível acessar a câmera. Verifique as permissões do navegador para ler o QR Code da comanda.';
  }





  pararCamera(): void {
    this.leituraEmProgresso = false;
  }




  async onCodeResult(result: string) {
    if(result){
      this.codigo = String(result).trim();
      this.leituraCartaoAberta = false;
      this.fecharLeituraCartao();
      return this.enviar();
    }

    this.leituraCartaoAberta = false;
    this.fecharLeituraCartao();
  }

  fecharLeituraCartao(): void {
    this.leituraCartaoAberta = false;
    this.pararCamera();
  }

  fechar() {
    this.dialogRef.close(false);
  }

}
